import { useState, useCallback, useRef, useEffect } from 'react'
import { Input, useOnOutsideClick } from '@panwds/react-ui'
import type { ChangeEventHandler, KeyboardEventHandler, VFC } from 'react'
import type { FavoritePreference } from '../../framework/stateTypes'

type FavoriteInputProps = {
  favoriteItem: FavoritePreference
  onEditComplete: (fav: FavoritePreference, newName: string) => void
}

const FavoriteInput: VFC<FavoriteInputProps> = ({ favoriteItem, onEditComplete }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [favName, setFavName] = useState<string>(favoriteItem.name)

  useEffect(() => {
    // Focus the first input field when the component mounts
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const onFavoriteKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      onEditComplete(favoriteItem, '')
    }
    if (event.key === 'Enter') {
      onEditComplete(favoriteItem, favName)
    }
  }, [onEditComplete, favoriteItem, favName]) as KeyboardEventHandler<HTMLInputElement>

  const onFavChange = useCallback((event) => {
    setFavName(event.target.value)
  }, []) as ChangeEventHandler<HTMLInputElement>


  useOnOutsideClick(inputRef, () => {
    onEditComplete(favoriteItem, favName)
  })

  console.log('favName ', favName)
  return (
    <div className='tw-p-2 tw-text-white'>
      <Input onKeyDown={onFavoriteKeyDown}
        value={favName}
        onChange={onFavChange}
        addClassName='favorite-input spf-border-none spf-bg-[#0B1117]'
        ref={inputRef}
      />
    </div>
  )
}

export default FavoriteInput
